import { FC } from "react";

import { LayoutType, TextAmenityColumn } from "./type";

interface CardTabTextProp {
  column: TextAmenityColumn;
}

const CardTabText: FC<CardTabTextProp> = ({ column }) => {
  return (
    <>
      <div
        className={`h-full flex flex-row items-center rounded-lg ${column.layout === LayoutType.HORIZONTAL ? "aspect-4-3 w-fix-tab-card" : "aspect-3-4"}`}
      >
        <p className="text-card-tab-text">{column.text}</p>
      </div>
    </>
  );
};
export default CardTabText;
